import { render, staticRenderFns } from "./DefaultNoHeading.vue?vue&type=template&id=1a3f23c8&scoped=true"
import script from "./DefaultNoHeading.vue?vue&type=script&lang=js"
export * from "./DefaultNoHeading.vue?vue&type=script&lang=js"
import style0 from "./DefaultNoHeading.vue?vue&type=style&index=0&id=1a3f23c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f23c8",
  null
  
)

export default component.exports